import React, {useEffect, useRef, useState} from 'react';
import logo from "../logo.svg";
import {useDispatch, useSelector} from "react-redux";

import i18n from "../resources/i18nSetup";
import {ValidationRule} from "../helpers/validationRule";
import {UseValidationForm} from "./useValidationForm";
import {Box, Button, Grid} from "@mui/material";
import Loading from "../helpers/loading";
import {PUBLIC_TRANSPORT_LIMIT_DATE, RESPONSE_STATUS} from "../constants";
import {downloadTicketByUUid, VoucherValidation} from "../redux/reducers/voucherPortalFormReducer";
function TicketDownload(props) {

  let initialValues = {};
  const [ticketDownload, setTicketDownload] = useState();
  const mountedRef = useRef();

  const dispatch = useDispatch();
  const ticketList = useSelector((state) =>
    state.VoucherPortalFormReducer.IssueTickets.response
  );

  const  classes = useSelector((state) =>
    state.VoucherPortalFormReducer.classes
  );

  const downloadTicketStatus = useSelector((state) =>
    state.VoucherPortalFormReducer.downloadTicketResponse.status
  );
  const voucherNumber = useSelector((state) =>
    state.VoucherPortalFormReducer.voucher_no
  );
  const downloadTicketResponse = useSelector((state) =>
    state.VoucherPortalFormReducer.downloadTicketResponse.response
  );

  const downloadTicket = (ticket) => {
    mountedRef.current = true
    setTicketDownload(ticket)
   dispatch(downloadTicketByUUid(ticket.uuid_ticket))
  }
  useEffect(() => {
    if (downloadTicketStatus === RESPONSE_STATUS.Succeeded && mountedRef.current) {
      let blob = new Blob([downloadTicketResponse]);
      let objectUrl = URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.style = "display:none";
      a.href = objectUrl;
      a.download = `${ticketDownload.first_name}_${ticketDownload.last_name}.pdf`;
      a.click();
    }
  }, [downloadTicketStatus]);

  return (
    <Grid item xs={12}>
        <Grid container  direction={"row"} spacing={1}>
          <Grid item xs={12}>
            <h2 class={classes && classes.h2_classes}>{i18n.t('downloadTitle')}</h2>
            <p class={classes && classes.p_classes.regular}>
              {i18n.t('voucherNumberSecondTitleDownloadScreen', {ticketNumber:voucherNumber})}
            </p>
          </Grid>
          <Grid item xs={12}>
            {ticketList.map((ticket, index) => (
              <Box key={index}>
                <Grid key={index} container sx={{justifyContent:"flex-start",pt:1}}   direction={"row"} spacing={0}>
                  <Grid item  xs={4}>
                    <p class={classes && classes.p_classes.regular}>{ticket.first_name + " " + ticket.last_name}</p>
                  </Grid>
                  <Grid item  >
                    <Loading status={downloadTicketStatus}>
                      <input  class={classes && classes.input_classes.submit} onClick={() => downloadTicket(ticket)} type={"button"} value={i18n.t("download")} />
                    </Loading>
                  </Grid>
                </Grid>
              </Box>
            ))}
          </Grid>
        </Grid>
    </Grid>
  );
}

export default TicketDownload
